import React, { useCallback } from 'react';
import { useEventInfo } from '@shared/utils/eventInfo';
import { useGuestGuideTelemetry } from '../GuestGuideTelemetry';
import { useTranslation } from '@shared/core';
import { GuestGuideActionButton } from '../GuestGuideActionButton';
import { Hotel } from '@withjoy/joykit/icons';
import { useHotelRoutePaths } from '@apps/guest/routes/HotelBooking/HotelBooking.routes';

export const HotelDealsAction: React.FC = () => {
  const { eventHandle } = useEventInfo();
  const telemetry = useGuestGuideTelemetry();
  const { t } = useTranslation('guestGuide');
  const hotelRoutePaths = useHotelRoutePaths();

  // This could be enhanced with feature flags or other business logic in the future

  const handleClick = useCallback(() => {
    telemetry.clickBrowseHotels();
  }, [telemetry]);

  return (
    <GuestGuideActionButton
      icon={<Hotel />}
      as="a"
      href={hotelRoutePaths.bookYourStay.buildRelativeUrl(eventHandle || '', {
        utm_campaign: 'guest_guide',
        utm_medium: 'web',
        utm_source: 'guest_guide_guest_site',
      })}
      onClick={handleClick}
    >
      {t('buttonTextHotelDeals')()}
    </GuestGuideActionButton>
  );
};
